import { Action } from "redux";
import { combineEpics } from "redux-observable";
import {resetEpic} from "./resetEpic";
import {processFilesEpic} from "./processFilesEpic";
import {uploadFileEpic} from "./uploadFileEpic";
import {progressEpic} from "./progressEpic";
import {retryEpic} from "./retryEpic";
import {addThumbnailEpic, generateThumbnailsEpic, syncDeleteEpic} from "./thumbnailEpic";
import {registerEpic} from "./registerEpic";
import {fetchGalleryEpic} from "./galleryEpic";

export const rootEpic = combineEpics<Action, Action, any, any>(
  resetEpic,
  registerEpic,
  retryEpic,
  progressEpic,
  processFilesEpic,
  uploadFileEpic,
  addThumbnailEpic,
  generateThumbnailsEpic,
  syncDeleteEpic,
  fetchGalleryEpic
);
